export enum TrafficLightStatus {
  ALERT = 'ALERT',
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING',
}
